// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__16eks","select":"Header_select__2bOT5","clinic":"Header_clinic__1C5FS"};